import React from 'react'
import PageLayout from './common/layout/PageLayout'
import { FOUNDERS } from '../config/founders'
import './FoundersPage.css'

function FounderRow({ founder }) {
  return (
    <article className="founder-row">
      <div className="founder-row__content">
        <p className="founder-row__label">{founder.role}</p>
        <h2 className="founder-row__name">{founder.name}</h2>
        <a className="founder-row__email" href={`mailto:${founder.email}`}>
          {founder.email}
        </a>
      </div>
    </article>
  )
}

function FoundersPage() {
  return (
    <PageLayout
      title="Founders"
      noCard={true}
      heroContent={<></>}
      showHeader={false}
    >
      <main className="founders-page">
        <section className="founders-hero">
          <p className="founders-hero__eyebrow">ServeSync Tennis</p>
          <h1 className="founders-hero__title">
            Built by players, for players.
          </h1>
          <p className="founders-hero__subtitle">
            Meet the founding team behind ServeSync Tennis.
          </p>
        </section>

        <section className="founders-grid" aria-label="Founders list">
          {FOUNDERS.map((founder) => (
            <FounderRow key={founder.email} founder={founder} />
          ))}
        </section>
      </main>
    </PageLayout>
  )
}

export default FoundersPage
